
import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const CabeceraOutDB = async ({ tipDoc, numDoc, date, tipoInOut, rut, entidad, rutSt, entidadSt, correo, patente, descripcion, tipMov, url, confirmado, entregado, retirado, observacion, userAdd, userMod, fechaAdd, fechaMod, emp_id }) => {

    return await addDoc(collection(db, 'salidasCab'), {
        numdoc: numDoc,
        tipdoc: tipDoc,
        date: date, 
        tipoinout: tipoInOut,
        rut: rut,
        entidad: entidad,
        rutst: rutSt,
        entidadst: entidadSt,
        correo: correo,
        patente: patente,
        descripcion: descripcion,
        tipmov: tipMov,
        url: url,
        confirmado: confirmado,
        entregado: entregado,
        retirado:retirado,
        observacion:observacion,
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod,
        emp_id: emp_id
    })
}

export default CabeceraOutDB;